<template>
  <div class="row items-center">
    <div
      :class="[justifyBetween ? 'col' : 'col-shrink']"
      class="q-mr-lg"
    >
      <WebbymizeLogo
        :to="{ name: ENUMS.ROUTES.AUTH.SIGNIN }"
        show-switcher
      />
    </div>
    <div
      :class="{'flex justify-end': justifyBetween}"
      class="col"
    >
      <LanguageSelector/>
    </div>
  </div>
</template>

<script>
import LanguageSelector from 'common/components/LanguageSelector';
import WebbymizeLogo from 'common/components/WebbymizeLogo';

export default {
  name: 'AuthHeader',
  components: {
    WebbymizeLogo,
    LanguageSelector,
  },
  props: {
    justifyBetween: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
